(() => {
  const init = (scope) => {
    scope.querySelectorAll('.sc-home').forEach((home) => {
      if (home.dataset.motionReady) return;
      home.dataset.motionReady = 'true';
      const ticker = home.querySelector('[data-motion-ticker]');
      const toggle = home.querySelector('[data-ticker-toggle]');
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      let paused = false;
      const sync = () => {
        if (!ticker || !toggle) return;
        ticker.classList.toggle('is-moving', !preference.matches);
        ticker.classList.toggle('is-paused', paused);
        toggle.hidden = preference.matches;
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.textContent = paused ? toggle.dataset.play : toggle.dataset.pause;
      };
      if (toggle) toggle.addEventListener('click', () => { paused = !paused; sync(); });
      preference.addEventListener('change', sync);
      sync();
      if ('IntersectionObserver' in window && !preference.matches) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('sc-is-inview');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12 });
        home.querySelectorAll('.sc-featured, .sc-categories, .sc-accessories').forEach((section) => observer.observe(section));
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
